module.exports = __webpack_public_path__ + "img/logoseebpontenova.f51c6124.png";